<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todos os investidores cadastrados até o
              momento. Toda nova conta criada aparecerá automaticamente na
              listagem abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="empty">
            <div class="row">
              <div class="col-12 text-center">
                <badge type="info" class="bg-white">
                  Não existem investidores cadastrados até o momento
                </badge>
              </div>
            </div>
          </div>
          <div v-else class="card-deck vld-parent" ref="investors_list">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="investor in investors"
              :key="investor.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="investor.profilePicture.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-8 pt-0">
                  <h2 class="card-title text-orange mb-1">
                    {{ investor.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ investor.city || "..." }},
                      {{ investor.state || "..." }}
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-envelope mr-2"></i
                        >{{ investor.user.email }}
                      </div>
                    </div>
                    <div class="h5 mt-3">
                      <badge
                        type="info"
                        class="text-dark"
                        title="Local de trabalho"
                      >
                        <i class="fas fa-briefcase mr-1"></i>
                        <span class="font-weight-bold">
                          {{ investor.working_place || "-" }}
                        </span>
                      </badge>
                    </div>
                    <div class="col-12 mt-3">
                      <badge
                        v-if="investor.account_validated"
                        type="success"
                        title="A conta do investidor está validada. Certifique-se de vinculá-lo a pelo menos um fundo de investimentos"
                      >
                        <i class="fas fa-info-circle mr-1"></i>
                        Conta validada
                      </badge>
                      <badge
                        v-else
                        type="warning"
                        title="Enquanto a conta não for validada o investidor não terá acesso as funcionalidades do portal"
                      >
                        <i class="fas fa-info-circle mr-1"></i>
                        Conta não validada
                      </badge>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <router-link
                    :to="'/admin/investidores/' + investor.user_id + '/editar'"
                    class="btn btn-white py-1 px-2"
                    title="Editar investidor"
                    ><i class="fas fa-edit text-info"></i
                  ></router-link>
                  <span
                    @click="handleOpenModalConfirmation(investor)"
                    class="btn btn-white py-1 px-2 cursor-pointer"
                    title="Deletar investidor"
                  >
                    <i class="fas fa-trash text-red"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 text-muted text-right">
              {{ investors.length }} investidores cadastrados ao total
            </div>
          </div>
        </div>
      </div>
      <hr :class="[empty ? 'mt-6' : 'mt-3', 'mb-1']" />
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            @click="$router.push('/admin/investidores-tabela')"
            >Visualizar como tabela</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o investidor
            <span class="text-warning">{{ modals.investorName }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as informações relacionadas ao investidor
            <span class="text-warning">{{ modals.investorName }}</span> ({{
              modals.investorEmail
            }}) serão perdidas.
          </p>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveInvestor"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "investor_list",
  data() {
    return {
      investors: [],
      empty: false,
      modals: {
        modalConfirmation: false,
        investorName: "",
        investorEmail: "",
        investorId: null,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.investors_list,
      width: 150,
      height: 150,
      opacity: 0,
    });
    try {
      const { data } = await api.get("/adm/investors");
      const defaultProfilePicture = "/img/pages/default_profile_picture.png";
      data.forEach((investor) => {
        if (!investor.profilePicture)
          investor.profilePicture = { url: defaultProfilePicture };
      });
      if (data.length) this.investors = data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os investidores");
    }
  },
  methods: {
    handleOpenModalConfirmation(investor) {
      this.modals.investorId = investor.user.id;
      this.modals.investorName = investor.name;
      this.modals.investorEmail = investor.user.email;
      this.modals.modalConfirmation = true;
    },
    handleCloseModalConfirmation() {
      this.modals.modalConfirmation = false;
      this.modals.investorId = null;
      this.modals.investorName = "";
      this.modals.investorEmail = "";
    },
    async handleSubmitRemoveInvestor() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/investors/${this.modals.investorId}`);
        this.$toasted.show("Investidor removido com sucesso");
        this.$router.go();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover o investidor");
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 145px;
  height: 145px;
  border-radius: 10%;
  margin: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.table-container {
  min-height: 150px;
}
</style>
